import React from 'react';
import { ModelFactory, ModelListEditor, ItemLayoutSelector } from '@leverege/ui-plugin';
import { Text, Flex, TabPane, Pane, Checkbox } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import { useValueChange } from '@leverege/ui-hooks';
import Model from './TableModel.js';
import Columns from '../Columns.js';
import ColumnListRenderer from "./ColumnListRenderer.js";
import S from './TableEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.table.TableEditor');
function contentHeader(item) {
  if (item == null) {
    return null;
  }
  const model = ModelFactory.get(item.type);
  let name;
  if (model) {
    name = model?.getName(item);
  }
  if (name == null) {
    name = item.displayName || item.name || item.type || t('unknown');
  }
  return /*#__PURE__*/_jsx(Text, {
    variant: "subtitle",
    children: name
  });
}
function TableEditor(props) {
  const {
    value,
    onChange,
    eventData,
    objectType,
    isSubEditor
  } = props;
  const onModelChange = useValueChange(Model, props);
  if (value == null) {
    return null;
  }
  const onAddColumn = evt => {
    const nModel = Model.columns().add(value, evt.value.create());
    onChange({
      data: eventData,
      value: nModel,
      oldValue: value
    });
  };
  const header = item => {
    const avail = Columns.getColumnsFor(objectType);
    return /*#__PURE__*/_jsx(Flex, {
      align: "center",
      justify: "space-between",
      children: /*#__PURE__*/_jsx(ItemLayoutSelector, {
        showFilter: true,
        options: avail,
        onSelect: onAddColumn,
        icon: "fa fa-plus",
        title: t('add')
      })
    });
  };
  const forward = e => {
    onChange({
      value: e.value,
      data: eventData
    });
  };
  return /*#__PURE__*/_jsxs(TabPane, {
    className: S.editor,
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('columns'),
      tabId: "columns",
      children: /*#__PURE__*/_jsx(ModelListEditor, {
        value: value,
        listClassName: S.list,
        listHeader: header,
        selectionHeader: contentHeader,
        model: Model.columns(),
        renderer: ColumnListRenderer,
        onChange: forward,
        selectedProps: {
          objectType,
          ...props
        }
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('options'),
      tabId: "options",
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colS",
        variant: "editor|padding",
        className: S.grid,
        children: [/*#__PURE__*/_jsx(Checkbox, {
          label: t('selectable'),
          eventData: "setSelectable",
          onChange: onModelChange,
          value: Model.getSelectable(value)
        }), !isSubEditor && /*#__PURE__*/_jsx(Checkbox, {
          label: t('allowExpandedView'),
          eventData: "setAllowExpandedView",
          onChange: onModelChange,
          value: Model.getAllowExpandedView(value)
        })]
      })
    })]
  });
}
export default TableEditor;